// extracted by mini-css-extract-plugin
export var googleReviews = "GoogleReviews-module--googleReviews--348fb";